import { createFeature, createReducer, on } from '@ngrx/store';
import { TareasActions } from './tareas.actions';
import { TareasState, initialTareasState } from './tareas.state';

const reducer = createReducer(
  initialTareasState,
  on(TareasActions.loadTareas, (state, { studentId }) => ({
    ...state, studentId, loading: true, error: null,
  })),
  on(TareasActions.loadTareasSuccess, (state, { tareas }) => ({
    ...state, tareas, loading: false,
  })),
  on(TareasActions.loadTareasFailure, (state, { error }) => ({
    ...state, loading: false, error,
  })),
);

export const tareasFeature = createFeature<'tareas', TareasState>({
  name: 'tareas',
  reducer,
});
